enum LoadingStatesActionType {
  RESET = 'loadingStates/RESET',
}

export default LoadingStatesActionType;
